import TrainingTimes from "../../../../src/components/training-times/TrainingTimes";
import Address from "../../../../src/components/address/Address";
import Sensei from "../../../../src/components/sensei/Sensei";
import * as React from 'react';
export default {
  TrainingTimes,
  Address,
  Sensei,
  React
};